<template>
    <div>
        <div class="head-container">
            <div style="margin-top: 10px">
                <div class="form-label" v-if="showMerchant">
                    <span>所属商家：</span>
                </div>
                <div class="form-input" v-if="showMerchant">
                    <Select v-model="formParam.merchantId" filterable clearable style="width: 260px">
                        <Option v-for="item in merchants" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="form-label" v-if="showStore">
                    <span>所属门店：</span>
                </div>
                <div class="form-input" v-if="showStore">
                    <Select v-model="formParam.storeId" filterable clearable style="width: 260px">
                        <Option v-for="item in storeList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="form-label">
                    <span>姓  名：</span>
                </div>
                <div class="form-input" style="width: 150px">
                    <Input v-model="formParam.name"/>
                </div>
                <div class="form-label">
                    <span>电话号码：</span>
                </div>
                <div class="form-input" style="width: 150px">
                    <Input v-model="formParam.phone"/>
                </div>
                <div class="form-label">
                    <span>身份证号：</span>
                </div>
                <div class="form-input">
                    <Input v-model="formParam.idCard"/>
                </div>
                <Button v-if="!showStore && !showMerchant" type="primary" icon="md-search"
                        @click="onQuery" style="margin-right: 10px">查询
                </Button>
                <Button v-if="!showStore && !showMerchant" icon="md-refresh" @click="reset" style="margin-right: 20px">重置</Button>
            </div>

            <div class="form-button" v-if="showStore || showMerchant">
                <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
                <Button icon="md-refresh" @click="reset" style="margin-right: 20px">重置</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="onShowModal">添加人员</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="resetPassword(row)">重置密码</Button>
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="setAuth(row)">权限</Button>
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="edit(row)">编辑</Button>
                    <Poptip
                        confirm
                        title="确定删除?"
                        @on-ok="remove(row)" placement="top-start" transfer>
                        <Button class="table-button-remove" size="small">删除</Button>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            title="添加人员"
            width="800"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formItem" :rules="rules" inline>
                    <FormItem label="姓  名" prop="name" class="my-form-item">
                        <Input v-model="formItem.name" placeholder="请输入姓名" class="my-form-input"></Input>
                    </FormItem>
                    <FormItem label="登录账号" prop="account" class="my-form-item">
                        <Input v-model="formItem.account" placeholder="请输入账号" class="my-form-input"></Input>
                    </FormItem>
                    <FormItem label="身份证号" prop="idCard" class="my-form-item">
                        <Input v-model="formItem.idCard" placeholder="请输身份证号" class="my-form-input"></Input>
                    </FormItem>
                    <FormItem label="联系电话" prop="phone" class="my-form-item">
                        <Input v-model="formItem.phone" placeholder="请输联系电话" class="my-form-input"></Input>
                    </FormItem>
                    <FormItem label="性  别" prop="gender" class="my-form-item">
                        <Select v-model="formItem.gender" filterable class="my-form-input">
                            <Option value="1" key="1">男</Option>
                            <Option value="2" key="2">女</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="年  龄" prop="age" class="my-form-item">
                        <Input v-model="formItem.age" placeholder="请输入年龄" class="my-form-input"></Input>
                    </FormItem>
                    <FormItem label="生   日" prop="birthday" class="my-form-item">
                        <DatePicker v-model="formItem.birthday" type="date" placeholder="请选择生日" class="my-form-input"/>
                    </FormItem>
                    <FormItem label="初始密码" prop="password" class="my-form-item" v-if="isNew">
                        <Input v-model="formItem.password" class="my-form-input" disabled></Input>
                    </FormItem>
                    <FormItem label="所属分组" prop="groupId" class="my-form-item">
                        <Select v-model="formItem.groupId" filterable class="my-form-input">
                            <Option v-for="item in userGroupList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="选择角色" prop="roleId" class="my-form-item" v-if="isNew">
                        <Select v-model="formItem.roleId" filterable class="my-form-input">
                            <OptionGroup label="系统角色">
                                <Option v-for="item in systemRoles" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                            </OptionGroup>
                            <OptionGroup label="我的角色">
                                <Option v-for="item in merchantRoles" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                            </OptionGroup>
                        </Select>
                    </FormItem>
                    <FormItem label="所属商家" prop="merchantId" v-if="userInfo.userType === 1" class="my-form-item">
                        <Select v-model="formItem.merchantId" filterable class="my-form-input" @on-change="merchantChange">
                            <Option v-for="item in merchants" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="所属门店" prop="storeId" v-if="userInfo.userType === 1 || userInfo.adminType === 2"
                              class="my-form-item">
                        <Select v-model="formItem.storeId" filterable class="my-form-input">
                            <Option v-for="item in storeList" :value="item.id + ''" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleOk">确定</Button>
                    <Button @click="handleCancel">取消</Button>
                </div>
            </div>
        </Modal>
        <Modal
            v-model="authSetting"
            title="权限设置"
            :styles="{top: '40px'}"
            footer-hide>
            <div>
                <div class="tree-container">
                    <div class="role-container">
                        <div class="type-title">角色设置</div>
                        <Tree :data="treeRoles" show-checkbox expand-node check-strictly @on-check-change="onRoleTreeChange"></Tree>
                    </div>
                    <div class="menu-container">
                        <div class="type-title">菜单设置</div>
                        <Tree :data="menus" show-checkbox expand-node check-strictly @on-check-change="onMenuTreeChange"></Tree>
                    </div>
                </div>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleAuthOk">确定</Button>
                    <Button @click="handleAuthCancel">取消</Button>
                </div>
            </div>
        </Modal>
        <Modal
            v-model="resetModal"
            title="重置密码"
            :styles="{top: '40px'}"
            footer-hide>
            <div>
                <div class="tree-container">
                    <Form :model="currentUser" :label-width="80" ref="formReset" :rules="rulesPassword" inline>
                        <FormItem label="设置密码" prop="password" class="my-form-item">
                            <Input v-model="currentUser.password" class="my-form-input"
                                   style="width: 360px" @input="checkPasswordStrength"></Input>
                        </FormItem>
                        <div class="password-strength">
                            <span :class="['strength-bar', strengthClass]"></span>
                            <span class="strength-text">{{ strengthText }}</span>
                        </div>
                    </Form>
                </div>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleResetOk">确定</Button>
                    <Button @click="handleResetCancel">取消</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    queryMerchantList,
    queryUserPage,
    queryStoreList,
    saveUser,
    removeUserInfo,
    queryUserAuthInfo,
    saveUserAuth,
    resetPassword,
    queryStoreByMerchant,
    queryRoleAndGroup,
} from "@/api"

export default {
    name: "UserManage",
    data() {
        const validatePassword = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('密码不能为空'))
            }
            // 密码强度验证逻辑
            const strongRegex = new RegExp(
                '^'
                + '(?=.*[a-z])'
                + '(?=.*\\d)'
                + '(?=.*[A-Z!@#$%^&*])'
                + '.{8,}'
                + '$'
            )

            const mediumRegex = new RegExp(
                '^'
                + '(?=.*[a-zA-Z])'
                + '(?=.*\\d)'
                + '[a-zA-Z\\d]'
                + '{8,}'
                + '$'
            )

            if (strongRegex.test(value)) {
                this.strengthClass = 'strong'
                this.strengthText = '强'
            } else if (mediumRegex.test(value)) {
                this.strengthClass = 'medium'
                this.strengthText = '中'
            } else {
                this.strengthClass = 'weak'
                this.strengthText = '弱'
                return callback(new Error('密码至少8位，至少包括字母和数字'))
            }

            callback()
        }
        return {
            formParam: {
                name: '',
                idCard: '',
                phone: '',
                merchantId: '',
                storeId: '',
                total: 0,
                current: 1,
                size: 10,
            },
            formItem: {
                name: '',
                account: '',
                phone: '',
                gender: '',
                age: '',
                idCard: '',
                birthday: '',
                password: '111111',
                merchantId: '',
                storeId: '',
                roleId: '',
            },
            columns: [
                {
                    title: '姓名',
                    key: 'name',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '账号',
                    key: 'account',
                    align: 'center',
                    width: 150,
                },
                {
                    title: '性别',
                    key: 'gender',
                    align: 'center',
                    width: 100,
                    render: this.renderGender,
                },
                {
                    title: '年龄',
                    key: 'age',
                    align: 'center',
                    width: 100,
                },
                {
                    title: '联系电话',
                    key: 'phone',
                    align: 'center',
                },
                {
                    title: '所属门店',
                    key: 'storeId',
                    align: 'center',
                    render: this.renderStoreName,
                },
                {
                    title: '所属分组',
                    key: 'groupId',
                    align: 'center',
                    render: this.renderGroupName,
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    width: 180,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 260,
                    align: 'center',
                },
            ],
            rules: {
                name: [
                    {required: true, message: '姓名不能为空', trigger: 'blur'},
                ],
                merchantId: [
                    {required: true, message: '所属商家不能为空', trigger: 'change'},
                ],
                storeId: [
                    {required: true, message: '所属门店不能为空', trigger: 'change'},
                ],
                account: [
                    {required: true, message: '登录账号', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '联系电话不能为空', trigger: 'blur'},
                ],
            },
            rulesPassword: {
                password: [
                    {validator: validatePassword, trigger: 'blur', required: true},
                ],
            },
            loading: false,
            modal: false,
            authSetting: false,
            storeList: [],
            merchants: [],
            showMerchant: false,
            showStore: false,
            userInfo: {},
            tableData: [],
            isNew: true,
            menus: [],
            selectMenus: [],
            selectRoles: [],
            currentUser: {},
            treeRoles: [],
            roleChange: false,
            menuChange: false,
            systemRoles: [],
            merchantRoles: [],
            userGroupList: [],
            resetModal: false,
            strengthClass: '',
            strengthText: '',
        }
    },
    created() {
        this.userInfo = JSON.parse(sessionStorage.getItem('current-user'))
        this.initShowInfo()
    },
    mounted() {
        this.queryRoleAndGroup()
        this.onQuery()
    },
    methods: {
        async initShowInfo() {
            if (this.userInfo.userType === 1) {
                await this.queryMerchantList()
                this.showMerchant = true
                this.showStore = false
            } else {
                this.showMerchant = false
                await this.queryStoreList()
            }
        },
        async queryRoleAndGroup() {
            let {data} = await queryRoleAndGroup()
            let roleList = data.roleList
            this.userGroupList = data.groupList
            for (let role of roleList) {
                if (role.merchantId === 0) {
                    this.systemRoles.push(role)
                } else {
                    this.merchantRoles.push(role)
                }
            }
        },
        renderGender(h, param) {
            let value = param.row.gender
            switch (value) {
                case 1:
                    return h('span', '男')
                case 2:
                    return h('span', '女')
                case "1":
                    return h('span', '男')
                case "2":
                    return h('span', '女')
                default:
                    return h('span', '未填写')
            }
        },
        async initTree() {
            let {data} = await queryUserAuthInfo(this.currentUser)
            let ms = []
            for (let menu of this.$store.state.menuItems) {
                if (!menu.hidden) {
                    ms.push(menu)
                }
            }
            for (let i = 0; i < ms.length; i++) {
                this.setNodeTitle(data.userMenuInfoList, ms[i])
            }
            this.menus = ms
            this.treeRoles = []
            let systemRole = {
                title: '系统角色',
                expand: true,
                children: [],
            }
            let customRole = {
                title: '我的角色',
                expand: true,
                children: [],
            }
            // eslint-disable-next-line no-restricted-syntax
            for (let role of data.roleInfoList) {
                role.title = role.name
                this.$set(role, 'checked', this.hasRole(data.userRoleInfoList, role.id))
                if (role.merchantId == 0) {
                    systemRole.children.push(role)
                } else {
                    customRole.children.push(role)
                }
            }
            if (systemRole.children.length > 0) {
                this.treeRoles.push(systemRole)
            }
            if (customRole.children.length > 0) {
                this.treeRoles.push(customRole)
            }
        },
        setNodeTitle(data, node) {
            if (node) {
                node.title = node.text
                node.expand = true
                this.$set(node, 'checked', this.hasAuth(data, node.id))
                if (node.children) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (let child of node.children) {
                        this.setNodeTitle(data, child)
                    }
                }
            }
        },
        renderStoreName(h, param) {
            let id = param.row.storeId
            if (id === 0) {
                return h('span', '总店')
            }
            for (let i = 0; i < this.storeList.length; i++) {
                if (this.storeList[i].id == id) {
                    return h('span', this.storeList[i].name)
                }
            }
            return h('span', '总店')
        },
        renderGroupName(h, param) {
            let id = param.row.groupId
            if (!id) {
                return h('span', '未分组')
            }
            for (let item of this.userGroupList) {
                if (item.id == id) {
                    return h('span', item.name)
                }
            }
            return h('span', '未知分组')
        },
        hasAuth(rmList, menuId) {
            for (let i = 0; i < rmList.length; i++) {
                if (rmList[i].menuId === menuId) {
                    return true
                }
            }
            return false
        },
        hasRole(urList, roleId) {
            for (let i = 0; i < urList.length; i++) {
                if (urList[i].roleId === roleId) {
                    return true
                }
            }
            return false
        },
        async onQuery() {
            let res = await queryUserPage(this.formParam)
            if (res.data != null) {
                this.tableData = res.data
                this.formParam.current = res.current
                this.formParam.total = res.total
            }
        },
        reset() {
            this.formParam = {
                name: '',
                idCard: '',
                phone: '',
                merchantId: '',
                storeId: '',
                total: 0,
                current: 1,
                size: 10,
            }
        },
        onShowModal() {
            this.formItem = {
                name: '',
                account: '',
                phone: '',
                gender: '',
                age: '',
                idCard: '',
                birthday: '',
                password: '111111',
                merchantId: '',
                storeId: '',
                roleId: '',
            }
            this.isNew = true
            this.modal = true
        },
        async queryStoreList() {
            let {data} = await queryStoreList()
            this.storeList = data
            if (this.userInfo.adminType == 2) {
                this.showStore = true
            } else {
                this.showStore = false
            }
        },
        merchantChange(e) {
            this.storeList = []
            this.formItem.storeId = ''
            this.queryStoreByMerchant(e)
        },
        queryStoreByMerchant(id) {
            queryStoreByMerchant({merchantId: id}).then((res) => {
                this.storeList = res.data
                if (this.userInfo.userType === 1 && id === '0') {
                    const item = {id: 0, name: '平台用户'}
                    this.storeList.unshift(item)
                }
            })
        },
        async queryMerchantList() {
            let {data} = await queryMerchantList()
            this.merchants = data
            const item = {id: 0, name: '平台用户'}
            this.merchants.unshift(item)
        },
        handleOk() {
            this.loading = true
            this.$refs.formItem.validate(async (valid) => {
                if (valid) {
                    saveUser(this.formItem).then(() => {
                        this.modal = false
                        this.onQuery()
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleCancel() {
            this.modal = false
        },
        edit(row) {
            this.formItem = Object.assign({}, row)
            this.formItem.merchantId = row.merchantId + ''
            this.isNew = false
            this.modal = true
        },
        setAuth(row) {
            this.currentUser = row
            this.roleChange = false
            this.menuChange = false
            this.initTree()
            this.authSetting = true
        },
        resetPassword(row) {
            this.currentUser = row
            this.resetModal = true
        },
        async remove(row) {
            await removeUserInfo(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
        onMenuTreeChange(selectedNodes) {
            this.selectMenus = selectedNodes
            this.menuChange = true
        },
        onRoleTreeChange(selectedNodes) {
            this.selectRoles = selectedNodes
            this.roleChange = true
        },
        handleAuthOk() {
            let param = {
                userInfo: this.currentUser,
                menuInfoList: this.selectMenus,
                roleInfoList: this.selectRoles,
                roleChange: this.roleChange,
                menuChange: this.menuChange,
            }
            saveUserAuth(param).then(() => {
                this.authSetting = false
            }).finally(() => {
                this.loading = false
            })
        },
        handleAuthCancel() {
            this.authSetting = false
        },
        handleResetOk() {
            this.$refs.formReset.validate((valid) => {
                if (valid) {
                    resetPassword(this.currentUser).then(() => {
                        this.$Message.success({
                            background: true,
                            content: '重置成功',
                        })
                        this.resetModal = false
                    }).finally(() => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },
        handleResetCancel() {
            this.resetModal = false
        },
        checkPasswordStrength() {
            this.$refs.formReset.validate()
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: auto;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
    width: 100%;
    text-align: left;
    margin-top: 20px;
    margin-left: 10px;
}

.my-form-item {
    margin-left: 20px;
}

.my-form-input {
    width: 260px;
}

.table-container {
    margin: 10px;
}

.role-container {
    position: relative;
    display: inline-block;
    width: 220px;
    border: 1px solid #97a8be;
    padding: 15px 10px 10px 10px;
    vertical-align: top;
}

.menu-container {
    position: relative;
    display: inline-block;
    width: 220px;
    border: 1px solid #97a8be;
    margin-left: 20px;
    padding: 15px 10px 10px 10px;
}

.type-title {
    position: absolute;
    left: 10px;
    top: -10px;
    background: white;
    padding: 0 5px;
    font-weight: bold;
}

.tree-container {
    max-height: 460px;
    overflow: auto;
    margin-bottom: 10px;
    padding-top: 10px;
}

.password-strength {
    padding-left: 100px;
    margin-bottom: 5px;
}

.strength-bar {
    display: inline-block;
    height: 6px;
    width: 100px;
    margin-right: 10px;
    background: #eee;
}

.strength-bar.weak {
    background: #ff5500;
    width: 33px;
}

.strength-bar.medium {
    background: #ffaa00;
    width: 66px;
}

.strength-bar.strong {
    background: #19be6b;
    width: 100px;
}

.strength-text {
    font-size: 12px;
    color: #999;
}
</style>
